import { useState } from "react"
import {  useSelector } from 'react-redux';


import PhoneStep from "./components/PhoneStep";
import CodeStep from "./components/CodeStep";
import { Navigate } from "react-router-dom";
import InfoStep from "./components/InfoStep";




export default function Login() {
    const isLoggedIn = useSelector((state) => state.login.token);
  
    const [step, setStep] = useState(1);
    const [phone, setPhone] = useState("");
    const [code, setCode] = useState("");
    const [token,setToken]=useState("")
    const [userInfo, setUserInfo] = useState({ name: "", email: "" });
    
 

    return (
      <>
        {step === 1 && (
          <PhoneStep
            phone={phone}
            setPhone={setPhone}
            onNext={() => setStep(2)}
          />
        )}
        {step === 2 && (
          <CodeStep
            code={code}
            phone={phone}
            setCode={setCode}
            setTokenn={setToken}
            onBack={() => setStep(1)}
            onNext={() => setStep(3)}
          />
        )}

        {step ===3 && (
          <InfoStep
          token={token}
            phone={phone}
            onBack={() => setStep(2)}

          />
        )}

      </>
    );
  }
  